<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!this.loading" class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
      <!-- カードが存在する場合 -->
      <div class="container" v-if="this.cardExists">
        <article class="mb20p">
          <section class="section white-panel pr0 mb2p">
            <div class="mr16">
              <p class="text-center">プリカNO:{{this.prepaidCard.card_info.card_no}}</p>
              <h2 class="text-center fs18 font-weight-bold">カード残高</h2>
              <p class="text-center fs32 line-height1 font-weight-bold mb8">{{$filters.addComma(this.prepaidCard.card_info.value_amount_sum)}}<span class="ml4 fs20 va-middle">円分</span></p>
              <p class="text-center color-red2 mb8">ご利用店舗：{{this.ssInfo.ss_name}}</p>
              <!-- DT洗車チャージ中止フラグ が 0(チャージ可) の場合は、次の画面へ遷移する -->
              <a class="button fs16 mt0 mb16 w85p" v-on:click="nextPage()" v-if="this.ssInfo.carwash_charge_discontinued_flag === 0">残高をチャージする</a>
              <!-- DT洗車チャージ中止フラグ が 1(チャージ不可) の場合は、非活性にする -->
              <button class="button fs16 mt0 mb16 w85p" disabled v-if="this.ssInfo.carwash_charge_discontinued_flag === 1">残高をチャージする</button>
              <p class="text-center mb8 fs14" v-if="this.ssInfo.carwash_charge_discontinued_flag === 1">現在このSSでは新規にチャージができません。</p>
            </div>
          </section>

          <section class="section white-panel mb2p" v-if="this.isAvailableInitialBenefit">
            <div id="existPrepaidCardElement" v-on:click="modalOpenInitialBenefit()">
              <img class="mr12" src="/lib/images/ic_coupon_l.svg"><span class="fs16">{{$filters.addComma(this.carwashSettings.initial_benefit_value)}}円分の初回特典をご利用頂けます</span>
            </div>
          </section>

          <section class="section white-panel mb2p">
            <h2 class="fs18 font-weight-bold mb4">有効期限</h2>
            <template v-if="this.prepaidCardList.length">
              <!-- カード：あり、データ：あり -->
              <table class="table w100p fs12 line-height1_7 mb20">
                <tbody>
                  <template v-if="!this.isShowMorePrepaidCardList">
                    <!-- もっと見る 前 最大 3 件 -->
                    <template v-for="(item, i) in this.prepaidCardMinimumList" :key="i">
                      <tr>
                        <td class="va-top fs14 bdb-solid-gray1 pt8 pb8">{{dateFormat(item.value_expire_datetime)}}（あと{{daysRemaining(item.value_expire_datetime)}}日）
                          <span v-if="expireWarning(item.value_expire_datetime)"><br><span class="color-red2 font-weight-bold">※ 有効期限が近づいています</span></span>
                        </td>
                        <td class="va-top fs14 bdb-solid-gray1 pt8 pb8 pr4 text-right">{{$filters.addComma(item.value_amount)}}円分</td>
                      </tr>
                    </template>
                  </template>
                  <template v-if="this.isShowMorePrepaidCardList">
                    <!-- もっと見る 後 全部表示 -->
                    <template v-for="(item, i) in this.prepaidCardList" :key="'0'+i">
                      <tr>
                        <td class="va-top fs14 bdb-solid-gray1 pt8 pb8">{{dateFormat(item.value_expire_datetime)}}（あと{{daysRemaining(item.value_expire_datetime)}}日）
                          <span v-if="expireWarning(item.value_expire_datetime)"><br><span class="color-red2 font-weight-bold">※ 有効期限が近づいています</span></span>
                        </td>
                        <td class="va-top fs14 bdb-solid-gray1 pt8 pb8 pr4 text-right">{{$filters.addComma(item.value_amount)}}円分</td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
              <button class="button button-gray fs16 mb12 w85p" v-if="showMorePrepaidCardList" v-show="!this.isShowMorePrepaidCardList" v-on:click="doShowMorePrepaidCardList()">もっと見る</button>
            </template>
            <template v-else>
              <!-- カード：あり、データ：なし -->
              <div style="margin-left: 14px;">
                <p class=""><span class="fs16">チャージ残高は０円です。</span></p>
              </div>
            </template>
          </section>

          <section class="section white-panel mb2p">
            <h2 class="fs18 font-weight-bold mb4">ご利用履歴</h2>
            <template v-if="this.chargeUsageMinimumList.length">
              <!-- カード：あり、データ：あり -->
              <table class="table w100p fs12 line-height1_7 mb20">
                <tbody>
                  <template v-if="!this.isShowMoreChargeUsageList">
                    <!-- もっと見る 前 最大 3 件 -->
                    <template v-for="(item, i) in this.chargeUsageMinimumList" :key="i">
                      <tr>
                        <td class="bdb-solid-gray1 fs14 pt8 pb8">{{dateFormat(item.usage_datetime)}}</td>
                        <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4">{{settlementKbn(item.settlement_kbn)}}</td>
                        <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4 text-right">{{ plusOrMinusSign(item.settlement_kbn) }}{{$filters.addComma(chargeUsageValue(item))}}円分</td>
                      </tr>
                    </template>
                  </template>
                  <template v-if="this.isShowMoreChargeUsageList">
                    <!-- もっと見る 後 最大件数表示 -->
                    <template v-for="(item, i) in this.chargeUsageMaximumList" :key="'0'+i">
                      <tr>
                        <td class="bdb-solid-gray1 fs14 pt8 pb8">{{dateFormat(item.usage_datetime)}}</td>
                        <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4">{{settlementKbn(item.settlement_kbn)}}</td>
                        <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4 text-right">{{ plusOrMinusSign(item.settlement_kbn) }}{{$filters.addComma(chargeUsageValue(item))}}円分</td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
              <button class="button button-gray fs16 mb12 w85p" v-if="this.showMoreChargeUsageList" v-show="!this.isShowMoreChargeUsageList" v-on:click="doShowMoreChargeUsageList()">もっと見る</button>
            </template>
            <template v-else>
              <!-- カード：あり、データ：なし -->
              <div style="margin-left: 14px;">
                <p class=""><span class="fs16">ご利用履歴はありません。</span></p>
              </div>
            </template>
          </section>

        </article>
      </div>
      <!-- カードが存在する場合 -->
      <!-- カードが存在しない場合 -->
      <div class="container" v-else>
        <article class="mb20p">
          <section class="section white-panel pr0 mb2p">
            <div class="mr16">
              <h2 class="text-center fs18 font-weight-bold">カード残高</h2>
              <p class="text-center fs32 line-height1 font-weight-bold mb8">0<span class="ml4 fs20 va-middle">円分</span></p>
              <p class="text-center color-red2 mb8">ご利用店舗：{{this.ssInfo.ss_name}}</p>
              <!-- DT洗車チャージ中止フラグ が 0(チャージ可) の場合は、次の画面へ遷移する -->
              <a class="button fs16 mt0 mb16 w85p" v-on:click="nextPage()" v-if="this.ssInfo.carwash_charge_discontinued_flag === 0">残高をチャージする</a>
              <!-- DT洗車チャージ中止フラグ が 1(チャージ不可) の場合は、非活性にする -->
              <button class="button fs16 mt0 mb16 w85p" disabled v-if="this.ssInfo.carwash_charge_discontinued_flag === 1">残高をチャージする</button>
              <p class="text-center mb8 fs14" v-if="this.ssInfo.carwash_charge_discontinued_flag === 1">現在このSSでは新規にチャージができません。</p>
            </div>
          </section>

          <section class="section white-panel mb2p" v-if="this.isAvailableInitialBenefit">
            <div id="notExistPrepaidCardElement" v-on:click="modalOpenInitialBenefit()">
              <img class="mr12" src="/lib/images/ic_coupon_l.svg"><span class="fs16">{{$filters.addComma(this.carwashSettings.initial_benefit_value)}}円分の初回特典をご利用頂けます</span>
            </div>
          </section>

          <section class="section white-panel mb2p">
            <h2 class="fs18 font-weight-bold mb4">有効期限</h2>
            <div style="margin-left: 14px;">
              <p class=""><span class="fs16">チャージ残高は０円です。</span></p>
            </div>
          </section>

          <section class="section white-panel mb2p">
            <h2 class="fs18 font-weight-bold mb4">ご利用履歴</h2>
            <div style="margin-left: 14px;">
              <p class=""><span class="fs16">ご利用履歴はありません。</span></p>
            </div>
          </section>

        </article>
      </div>
      <!-- カードが存在しない場合 -->

      <div class="modal_overlay">
        <div class="modal_container">
          <div class="modal_body radius8 pd24 mt8p mb8p">
            <div class="mb4 mg-auto modal-image-size75"><p class=""><img class="mr12" src="/lib/images/Group1483.png"></p></div>
            <div>
              <h2 class="fs18 mb8 color-green2 mg-auto text-center" style="">お試し{{$filters.addComma(this.carwashSettings.initial_benefit_value)}}円分をプレゼント</h2>
              <h2 class="fs18 mb8 mg-auto text-center">「{{this.ssInfo.ss_name}}」で使いますか？</h2>
              <p class="fs14 mb16">プレゼント分残高は、別のSSではご利用頂けません。別のSSでご利用したい場合は、一度キャンセルをしてマイSSを変更後、TOP画面より「洗車」→「お試し分受取り」の手順でお進みください。</p>
            </div>
            <button v-bind:disabled="processing" v-on:click="doInitialBenefitCharge()" class="button fs16 w100p mt16 mb0 pd16 radius200">このSSで使う</button>
            <button v-bind:disabled="processing" v-on:click="modalCloseInitialBenefit()" class="button button-gray fs16 w100p mt16 mb0 pd16 radius200">キャンセル</button>
          </div>
          <!-- /.modal_body -->
        </div>
        <!-- /.modal_container -->
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import carwashSettingsApi from '@/store/Api/carwashSettings'
import prepaidCardApi from '@/store/Api/prepaidCard'
import prepaidCardChargeUsedHistoryApi from '@/store/Api/prepaidCardChargeUsedHistory'
import prepaidCardInitialBenefitChargeApi from '@/store/Api/prepaidCardInitialBenefitCharge'
import ssApi from '@/store/Api/ss'
import Loading from '@/views/v1/Loading'
import modal from '@/assets/v1/modal'
import moment from 'moment'
import config from '@/commons/v1/config'

export default {
  data () {
    return {
      loading: true,
      cardExists: false,
      ssInfo: [],
      isShowMorePrepaidCardList: false,
      isShowMoreChargeUsageList: false,
      modalActive: false,
      processing: false,
      createdPrepaidCard: {
        card_no: null,
        pin_cd: null
      },
      // 初回特典の利用状況(0: 未使用, 1: 使用済み)
      initialBenefitUsed: 0
    }
  },
  methods: {
    ...mapActions('PREPAID_CARD', [
      'setPrepaidCard'
    ]),
    ...mapActions('PREPAID_CARD_CHARGE_USED_HISTORY', [
      'setPrepaidCardChargeUsedHistory'
    ]),
    ...mapActions('CARWASH_SETTINGS', [
      'setCarwashSettings'
    ]),
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    setCreatedPrepaidCard (prepaidCard) {
      this.createdPrepaidCard = prepaidCard
    },
    setInitialBenefitUsed (initialBenefitUsed) {
      this.initialBenefitUsed = initialBenefitUsed
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    doShowMorePrepaidCardList () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashHistoryButton', 'SEE_MORE_YUKOKIGEN', 'TAP')
      this.isShowMorePrepaidCardList = true
    },
    doShowMoreChargeUsageList () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashHistoryButton', 'SEE_MORE_HISTORY', 'TAP')
      this.isShowMoreChargeUsageList = true
    },
    modalCloseInitialBenefit () {
      // [eventTrack]
      this.nativeEVENTSet('HistoryChargePopupButton', 'CANCEL_SYOKAI_TOKUTEN', 'TAP')
      this.modalActive = false
    },
    modalOpenInitialBenefit () {
      // [eventTrack]
      this.nativePVset('HISTORY_CARWASH_SYOKAI_CHARGE_POPUP')
      window.scrollTo(0, 0)
      this.modalActive = true
    },
    nextPage () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashChargeButton', 'MOVED_CHARGE', 'TAP')
      // DT洗車 利用規約表示 恒久対応
      // ref: https://gitlab.ssl.iridge.jp/cosmo-oil/carwash-front/-/issues/34
      if (this.cardExists && this.prepaidCardChargeUsedHistory.normal_charged === config.CHARGE_USED_HISTORY_NORMAL_CHARGED_CHARGED) {
        // カードが存在し、過去に決済済みなので、チャージ画面へ
        this.toCharge()
      } else {
        // カードが存在しない、または、カード発行済みだがまだ決済したことがないため、初回規約画面へ
        this.toAgreement()
      }
    },
    toAgreement () {
      // 初回利用同意画面へ遷移
      this.$router.push({
        name: 'V1InitialAgreement',
        query: {
          tsid: this.nativeData.tsid,
          otoken: this.nativeData.otoken,
          popinfoid: this.nativeData.popinfoid,
          authid: this.nativeData.authid,
          ss_code: this.nativeData.ss_code,
          card_no: this.nativeData.card_no,
          pin_cd: this.nativeData.pin_cd
        }
      })
    },
    toCharge () {
      // チャージ画面へ遷移
      this.$router.push({
        name: 'V1Charge',
        query: {
          tsid: this.nativeData.tsid,
          otoken: this.nativeData.otoken,
          popinfoid: this.nativeData.popinfoid,
          authid: this.nativeData.authid,
          ss_code: this.nativeData.ss_code,
          card_no: this.nativeData.card_no,
          pin_cd: this.nativeData.pin_cd
        }
      })
    },
    reload (query) {
      const r = this.$router.resolve({
        name: this.$route.name,
        params: this.$route.params,
        query
      })
      console.log(r.href)
      window.location.assign(r.href)
    },
    async doInitialBenefitCharge () {
      // 二度押しロック
      this.processing = true
      let isApiError = false
      // [eventTrack]
      this.nativeEVENTSet('HistoryChargePopupButton', 'USE_SYOKAI_TOKUTEN', 'TAP')

      if (this.cardExists) {
        // カードが存在するので、初回特典チャージのみ
        const postData = {
          card_no: this.nativeData.card_no,
          pin_cd: this.nativeData.pin_cd,
          charge_value_amount: this.carwashSettings.initial_benefit_value
        }

        await prepaidCardInitialBenefitChargeApi.post(this.nativeData.authid, this.nativeData.ss_code, postData).then(res => {
          console.log(res)
          // リロード
          const query = {
            tsid: this.nativeData.tsid,
            otoken: this.nativeData.otoken,
            popinfoid: this.nativeData.popinfoid,
            authid: this.nativeData.authid,
            ss_code: this.nativeData.ss_code,
            card_no: this.nativeData.card_no,
            pin_cd: this.nativeData.pin_cd
          }
          this.reload(query)
        }).catch(e => { // eslint-disable-line no-unused-vars
          console.log('prepaidCardInitialBenefitChargeApiPost-error')
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
          // 二度押しロック解除
          this.processing = false
        })
      } else {
        // カードが存在しないので、プリペイドカード新規発行
        await prepaidCardApi.post(this.nativeData.authid, this.nativeData.ss_code).then(res => {
          this.setCreatedPrepaidCard(res.data.body)
        }).catch(e => { // eslint-disable-line no-unused-vars
          console.log('prepaidCardApiPost-error')
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
          // 二度押しロック解除
          this.processing = false
        })

        if (!isApiError) {
          // 発行したプリペイドカードで初回特典チャージ
          const postData = {
            card_no: this.createdPrepaidCard.card_no,
            pin_cd: this.createdPrepaidCard.pin_cd,
            charge_value_amount: this.carwashSettings.initial_benefit_value
          }
          await prepaidCardInitialBenefitChargeApi.post(this.nativeData.authid, this.nativeData.ss_code, postData).then(res => {
            console.log(res)
            // リロード
            const query = {
              tsid: this.nativeData.tsid,
              otoken: this.nativeData.otoken,
              popinfoid: this.nativeData.popinfoid,
              authid: this.nativeData.authid,
              ss_code: this.nativeData.ss_code,
              // 発行したカード番号,PINコード
              card_no: this.createdPrepaidCard.card_no,
              pin_cd: this.createdPrepaidCard.pin_cd
            }
            this.reload(query)
          }).catch(e => { // eslint-disable-line no-unused-vars
            console.log('prepaidCardApiPost-error')
            if (!isApiError) {
              this.openErrorModal('エラーが発生しました。')
              isApiError = true
            }
            // 二度押しロック解除
            this.processing = false
          })
        }
      }
    },
    dateFormat: function (date) {
      return moment(date).format('YYYY.MM.DD')
    },
    daysRemaining: function (date) {
      const now = moment()
      return moment(date).diff(now, 'days')
    },
    settlementKbn: function (settlement_kbn) {
      if (settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_CHARGED) {
        return '残高チャージ'
      } else if (settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_USED) {
        return '洗車'
      }
      return ''
    },
    chargeUsageValue: function (history) {
      if (history.settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_CHARGED) {
        // バリューチャージ
        return history.charge_designated_limit_value
      } else if (history.settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_USED) {
        // バリュー利用
        return history.usage_limit_value_amount
      }
      return ''
    },
    plusOrMinusSign: function (settlement_kbn) {
      if (settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_CHARGED) {
        return '+'
      } else if (settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_USED) {
        return '-'
      }
      return ''
    }
  },
  computed: {
    ...mapGetters('PREPAID_CARD', [
      'prepaidCard'
    ]),
    ...mapGetters('PREPAID_CARD_CHARGE_USED_HISTORY', [
      'prepaidCardChargeUsedHistory'
    ]),
    ...mapGetters('CARWASH_SETTINGS', [
      'carwashSettings'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したクエリパラメータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      getData.authid = this.$route.query.authid
      getData.ss_code = this.$route.query.ss_code
      getData.card_no = this.$route.query.card_no
      getData.pin_cd = this.$route.query.pin_cd
      return getData
    },
    // 有効期限リスト
    prepaidCardList: function () {
      const limitValueList = this.prepaidCard.card_info.limit_value_list ?? []
      // バリュー有効期限日時 の 昇順
      return limitValueList.sort(function (a, b) {
        if (a.value_expire_datetime < b.value_expire_datetime) return -1
        if (a.value_expire_datetime > b.value_expire_datetime) return 1
        return 0
      })
    },
    // 有効期限の初期表示件数
    prepaidCardMinimumNum: () => 3,
    // 有効期限のxx日前に注意喚起表示
    expireWarningDaysNum: () => 31,
    // 有効期限の初期表示リスト
    prepaidCardMinimumList: function () {
      if (this.prepaidCardList) {
        return this.prepaidCardList.slice(0, this.prepaidCardMinimumNum)
      }
      return []
    },
    // 有効期限が近づいています判定
    expireWarning: function () {
      const vm = this
      return function (expireDate) {
        const warningDate = moment(expireDate).subtract(vm.expireWarningDaysNum, 'days')
        const now = moment()
        // 有効期限のxx日前を超えているか
        return now.isSameOrAfter(warningDate)
      }
    },
    // 有効期限のもっと見るボタン表示判定
    showMorePrepaidCardList: function () {
      if (this.prepaidCard.card_info.limit_value_list) {
        return this.prepaidCard.card_info.limit_value_list.length > this.prepaidCardMinimumNum
      }
      return false
    },
    // 利用履歴リスト（取引種別:020,030）
    chargeUsageList: function () {
      if (this.prepaidCardChargeUsedHistory.card_usage_info_listV2) {
        // 取引種別が020,030の利用履歴
        const cardUsageInfoListV2 = this.prepaidCardChargeUsedHistory.card_usage_info_listV2.filter(function (history) {
          return history.settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_CHARGED || history.settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_USED
        })
        // 利用日時 の 降順
        return cardUsageInfoListV2.sort(function (a, b) {
          if (a.usage_datetime > b.usage_datetime) return -1
          if (a.usage_datetime < b.usage_datetime) return 1
          return 0
        })
      }
      return []
    },
    // 利用履歴の初期表示件数
    chargeUsageMinimumNum: () => 7,
    // 利用履歴の最大表示件数
    chargeUsageMaximumNum: () => 50,
    // 利用履歴の初期表示リスト
    chargeUsageMinimumList: function () {
      return this.chargeUsageList.slice(0, this.chargeUsageMinimumNum)
    },
    // 利用履歴の最大表示リスト
    chargeUsageMaximumList: function () {
      return this.chargeUsageList.slice(0, this.chargeUsageMaximumNum)
    },
    // 利用履歴のもっと見るボタン表示判定
    showMoreChargeUsageList: function () {
      return this.chargeUsageList.length > this.chargeUsageMinimumNum
    },
    // 初回特典の利用可否
    // DT洗車設定(初回特典ステータス):true かつ 初回特典を利用していない場合
    isAvailableInitialBenefit: function () {
      return this.carwashSettings.carwash_initial_benefit_charges_flag && !this.initialBenefitUsed
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    let isApiError = false

    // SS
    await ssApi.get(this.nativeData.ss_code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      console.log('ss-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // DT洗車設定情報取得
    await carwashSettingsApi.get().then(res => {
      this.setCarwashSettings(res.data)
      console.log(this.carwashSettings)
    }).catch(e => {
      console.log('carwash-settings-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (this.nativeData.card_no && this.nativeData.pin_cd) {
      // カード番号, PINコードが存在する
      this.cardExists = true

      // DT洗車プリペイドカード情報取得
      await prepaidCardApi.get(this.nativeData.authid, this.nativeData.ss_code).then(res => {
        this.setPrepaidCard(res.data.body)
        // 初回特典利用有無を保持
        this.setInitialBenefitUsed(res.data.body.initial_benefit_used)
      }).catch(e => {
        console.log('get-prepaidCard-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })

      // DT洗車バリューチャージ利用履歴取得
      await prepaidCardChargeUsedHistoryApi.get(this.nativeData.authid, this.nativeData.ss_code).then(res => {
        this.setPrepaidCardChargeUsedHistory(res.data.body)
      }).catch(e => {
        console.log('get-prepaidCardChargeUsedHistory-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    } else {
      // プリペイドカードは存在しないので 404 のレスポンスとなるが、
      // 初回特典利用の有無を取得するため、プリペイドカードDT洗車プリペイドカード情報取得APIをコールする
      // eslint-disable-next-line no-unused-vars
      await prepaidCardApi.get(this.nativeData.authid, this.nativeData.ss_code).then(res => {
      }).catch(e => {
        if (e.response.status === 404) {
          // 初回特典の利用有無
          console.log(e.response.status)
          console.log(e.response.data)
          // 初回特典利用有無を保持
          this.setInitialBenefitUsed(e.response.data.body.initial_benefit_used)
        } else {
          // 404 以外のエラー
          console.log('get-prepaidCard-error')
          console.log(e.message)
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        }
      })
    }

    // [eventTrack]
    this.nativePVset('CARWASH_HISTORY')

    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}
</script>
